export type StatusClassPattern = [RegExp, string];

export interface StatusBadgeClassOptions {
  exactMap?: Record<string, string>;
  patterns?: StatusClassPattern[];
  defaultClass?: string;
}

const EXACT_STATUS_CLASS_MAP: Record<string, string> = {
  New: 'status-new',
  Quoted: 'status-quoted',
  PendingSubmission: 'status-pending',
  'Pending Submission': 'status-pending',
  LinkSent: 'status-pending',
  'Link Sent': 'status-pending',
  PendingEsign: 'status-pending',
  'Pending Esign': 'status-pending',
  EnrollmentSubmitted: 'status-enrollment-submitted',
  'Enrollment Submitted': 'status-enrollment-submitted',
  Completed: 'status-completed',
  Cancelled: 'status-cancelled',
  Expired: 'status-expired',
  Pending: 'status-pending',
  Approved: 'status-approved',
  Rejected: 'status-rejected',
  PlansList: 'status-plans-list',
  'Plans List': 'status-plans-list',
  PlanOptions: 'status-plans-list',
};

const STATUS_CLASS_PATTERNS: StatusClassPattern[] = [
  [/pending/, 'status-pending'],
  [/link\s*sent/, 'status-pending'],
  [/approved/, 'status-approved'],
  [/rejected/, 'status-rejected'],
  [/enrollment.*submitted|submitted.*enrollment/, 'status-enrollment-submitted'],
  [/expired/, 'status-expired'],
  [/new/, 'status-new'],
  [/quoted/, 'status-quoted'],
  [/completed/, 'status-completed'],
  [/cancelled/, 'status-cancelled'],
  [/plans.*list/, 'status-plans-list'],
  [/plan.*options/, 'status-plans-list'],
];

export function getStatusBadgeClass(status?: string | null, options: StatusBadgeClassOptions = {}): string {
  const fallback = options.defaultClass ?? 'status-default';

  if (!status) {
    return fallback;
  }

  const trimmed = String(status).trim();
  if (!trimmed) {
    return fallback;
  }

  const overrideExact = options.exactMap?.[trimmed];
  if (overrideExact) {
    return overrideExact;
  }

  const exact = EXACT_STATUS_CLASS_MAP[trimmed];
  if (exact) {
    return exact;
  }

  const lower = trimmed.toLowerCase();
  const overrideMatch = options.patterns?.find(([pattern]) => pattern.test(lower));
  if (overrideMatch) {
    return overrideMatch[1];
  }

  const match = STATUS_CLASS_PATTERNS.find(([pattern]) => pattern.test(lower));
  return match ? match[1] : fallback;
}
